/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Exp_Aerobic_Te_One_LinerInputs */

const en_exp_aerobic_te_one_liner = /** @type {(inputs: Exp_Aerobic_Te_One_LinerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`How much this session improved your aerobic endurance, on a 0–5 scale.`)
};

const de_exp_aerobic_te_one_liner = /** @type {(inputs: Exp_Aerobic_Te_One_LinerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wie stark diese Einheit deine aerobe Ausdauer verbessert hat — Skala von 0–5.`)
};

/**
* | output |
* | --- |
* | "How much this session improved your aerobic endurance, on a 0–5 scale." |
*
* @param {Exp_Aerobic_Te_One_LinerInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const exp_aerobic_te_one_liner = /** @type {((inputs?: Exp_Aerobic_Te_One_LinerInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Exp_Aerobic_Te_One_LinerInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_exp_aerobic_te_one_liner(inputs)
	return de_exp_aerobic_te_one_liner(inputs)
});